import { createRequiredContext } from '@ha/utilities/React/RequiredContext';

import { PageContextValue } from './types';

export const PageContext =
  createRequiredContext<PageContextValue>('PageContext');
